import React from 'react';

import { TimeOffViewComponent } from './TimeOffView.Component';
import { httpServices } from '../../../services/httpServices';
import { history } from './../../../helpers/history';
import { ErrorPage } from '../../common/error';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import * as _R from 'ramda';

const formFields = {
    'reason' : '',
    'comment' : '',
}

export class TimeOffViewContainer extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            id : 0,
            requests : '',
            dialogOpen : false,
            snackbarOpen : false,
            popup : '',
            errors: {},
            formFields : formFields,
            hasPermission: true,
            showLoader : true,
            selfEdit : false,
            snackbarMsg : '',
            snackbarMsgType : 'success', 
            buttonDisabled : false,
            editComment : false,
            commentId : 0,
            comments : [],
            commentsLoaded : false,
            commentAction : '',
            hrPermission : false,
            loggedUser : 0
        }
        this.getTimeoffDetails = this.getTimeoffDetails.bind(this);
        this.viewRelatedTimeoff = this.viewRelatedTimeoff.bind(this);
        this.approvebtnClick = this.approvebtnClick.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.submitReviewRequest = this.submitReviewRequest.bind(this);
        this.unApprovebtnClick = this.unApprovebtnClick.bind(this);
        this.rejectbtnClick = this.rejectbtnClick.bind(this);
        this.commentbtnClick = this.commentbtnClick.bind(this);
        this.cancelbtnClick = this.cancelbtnClick.bind(this);
        this.tokenbtnClick = this.tokenbtnClick.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.editClick = this.editClick.bind(this);
        this.updateParentOnEditSuccess = this.updateParentOnEditSuccess.bind(this);
        this.closeLoader = this.closeLoader.bind(this);
        this.handleCommentActions = this.handleCommentActions.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentDidMount = () => {
        let id = (this.props.match.params.id) ? this.props.match.params.id: false;
        this.setState({
            id : id
        });
        this.getTimeoffDetails(id);
    };
    getTimeoffDetails = (id) =>{
        let apiEndpoint = 'api/request/timeoff/view';
        let data = {
            'id' : id,
        };
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data && response.data.permission) {
                    this.setState({
                        request : response.data,
                        //snackbarMsg : response.data.message,
                        snackbarMsgType : response.data.message_type,
                        showLoader : false,
                        selfEdit : response.data.self_edit,
                        hrPermission : response.data.hr_user_permission,
                        loggedUser : response.data.logged_user,
                        comments : response.data.comments,
                        commentsLoaded : true
                    });
                }
                else {
                    this.setState({
                        hasPermission : false,
                        showLoader : false,
                    });
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    };
    editClick = () => {
        this.setState({
            popup : 'edit',
            dialogOpen : true,
            showLoader : true,
        });
    }
    viewRelatedTimeoff = (id) => {
        if(id) {
            history.push(id);
            this.setState({
                id : id,
                showLoader : true,
            });
            this.getTimeoffDetails(id);
            window.scrollTo(0, 0);

        }
    }
    handleOnChange = (evt, value) => {
        const f = this.state.formFields;
        const name = evt.target.name;
        const val = evt.target.value;
        if (name === 'approve_related') {
            f[name] = evt.target.checked;
        }
        else {
            f[name] = val;
        }
        this.setState({
            formFields: f,
        });
        if (val) {
            var err = this.state.errors;
            err[name] = '';
            this.setState({errors: err});
        }
    };
    onClose = () => {
        this.setState({
            dialogOpen : false,
            errors: {},
            commentId : 0,
            editComment :false,
        },function() {
            this.clearForm();
        }
        );
    }
    clearForm = () => {
        const ff = this.state.formFields;
        for (let key in ff) {
            ff[key] = '';
        }
        this.setState({
            errors: {},
            formFields: ff,
        });
    };
    approvebtnClick = () => {
        //Display Approve popup
        this.setState({
            popup : 'approve',
            dialogOpen : true,
            buttonDisabled : false
        });
    }
    unApprovebtnClick = () => {
        this.setState({
            popup : 'unapprove',
            dialogOpen : true,
            buttonDisabled : false
        });
    }
    rejectbtnClick = () => {
        this.setState({
            popup : 'reject',
            dialogOpen : true,
            buttonDisabled : false
        });
    }
    commentbtnClick = (action,editId = 0) => {
        if (editId) {
            let data = {
                'commentId' : editId,
                'action' : 'edit',
                'id' : this.state.id,
            };
            return httpServices.post('api/request/timeoff/comment', data)
                .then(response => {
                if (response.data.self_edit_permission) {
                    let f = this.state.formFields;
                    f['comment'] = response.data.comment.comment;
                    this.setState({
                        formFields : f,
                        popup : 'comment',
                        dialogOpen : true,
                        buttonDisabled : false,
                        editComment :true,
                        commentId : editId 
                    });
                }    
            })
        }
        else {
            this.setState({
                commentId : 0,
                editComment :false,
                popup : 'comment',
                dialogOpen : true,
                buttonDisabled : false,
                
            });
        }
    }
    
    handleCommentActions = (action) => {
       if (action == 'edit') {
            let id = this.state.id;
            let action = this.state.popup;
            let editComment = this.state.editComment;
            let data = this.state.formFields;
            let commentId = this.state.commentId;
            data.id = id;
            data.action = action;
            data.editComment = editComment;
            data.commentId = commentId;
            let valid = this.validateSubmit(action);
            if (valid) {
                return httpServices.post('api/request/timeoff/comment', data)
                .then(response => {
                    if (response.data.self_edit_permission) {
                        this.setState({
                            dialogOpen : false,
                            comments : response.data.comments,
                            commentsLoaded : true,
                        }, function () {
                            this.clearForm();
                        });
                    }
                })            
            }     
       }
       else {
            let data = {};
            let id = this.state.id;
            let commentId = this.state.commentId;
            data.commentId = commentId;
            data.action = 'delete';
            data.id = id;
             return httpServices.post('api/request/timeoff/comment', data)
                .then(response => {
                    if (response.data.self_delete_permission) {
                    this.setState({
                            dialogOpen : false,
                            comments : response.data.comments,
                            commentsLoaded : true,
                        });
                }
            })

       }
    }
    
    cancelbtnClick = () => {
        this.setState({
            popup : 'cancel',
            dialogOpen : true,
            buttonDisabled : false
        });
    }
    tokenbtnClick = () => {
        this.setState({
            popup : 'token_generate',
        },function() {
            this.submitReviewRequest();
        });
    }
    submitReviewRequest = () => {
        let id  =this.state.id;
        let action = this.state.popup;
        let data = this.state.formFields;
        data.id = id;
        data.action = action;
        let valid = this.validateSubmit(action);
        if (valid) {
            this.setState({
                showLoader : true,
                buttonDisabled : true
            });
            return httpServices.post('api/request/timeoff/view', data)
                .then(response => {
                    if (response.data.message_type === 'success') {
                        this.setState({
                            request : response.data,
                            comments : response.data.comments,
                            commentsLoaded : true,
                            snackbarMsg : response.data.message,
                            snackbarMsgType : response.data.message_type,
                            snackbarOpen : true,
                            showLoader : false,
                            dialogOpen : false,
                        });
                    } else if (response.data.message_type === 'error'){
                        if (response.data.errors.length){
                            this.setState({
                                errors: response.data.errors,
                                showLoader : false,
                            });
                        } else if (response.data.message){
                            this.setState({
                                snackbarMsg: response.data.message,
                                snackbarMsgType: response.data.message_type,
                                snackbarOpen: true,
                                showLoader: false,
                                dialogOpen: false,
                            });
                        }
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
        }
    }
    validateSubmit = (action) => {
        let valid = true;
        let errors = {};
        if (action === 'unapprove' || action === 'reject' || action === 'comment') {
            let comment = this.state.formFields.comment;
            if (_R.length(comment.trim()) === 0) {
                valid = false;
                errors['comment'] = "Comment cannot be empty";
            }
        }
        this.setState({errors: errors});
        return valid;
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }
    updateParentOnEditSuccess = (status) => {
        if ( status ) {
            this.setState({
                snackbarOpen : true,
                snackbarMsg : "Request updated successfully",
                snackbarMsgType : 'success',
                dialogOpen : false,
            }, function () {
                this.getTimeoffDetails(this.state.id);
            });
        } else {
            this.setState({
                dialogOpen : false,
            });
        }
    }
    closeLoader = () => {
        this.setState({
            showLoader: false,
        });
    }
    onDelete = (action, commentId) => {
        this.setState({
                commentAction : action,
                commentId : commentId,
                dialogOpen : true,
                popup : 'delete-comment',
            });
    }
    render(){
        return(
            <>
            <CustomProgressBar
                loaderOpen={this.state.showLoader}
            />
            {(this.state.hasPermission)
            ?
            <TimeOffViewComponent 
            Request = {this.state.request}
            ViewRelatedTimeoff = {this.viewRelatedTimeoff}
            ApprovebtnClick = {this.approvebtnClick}
            UnApprovebtnClick = {this.unApprovebtnClick}
            RejectbtnClick = {this.rejectbtnClick}
            CommentbtnClick = {this.commentbtnClick}
            CancelbtnClick = {this.cancelbtnClick}
            TokenbtnClick = {this.tokenbtnClick}
            HandleOnChange = {this.handleOnChange}
            OnClose = {this.onClose}
            SubmitReviewRequest = {this.submitReviewRequest}
            DialogOpen = {this.state.dialogOpen}
            SnackbarOpen = {this.state.snackbarOpen}
            Popup = {this.state.popup}
            Errors = {this.state.errors}
            FormFields = {this.state.formFields}
            SnackbarClose = {this.snackbarClose}
            SelfEdit = {this.state.selfEdit}
            EditClick = {this.editClick}
            Id = {this.state.id}
            SnackbarMsg = {this.state.snackbarMsg}
            SnackbarMsgType = {this.state.snackbarMsgType}
            UpdateParentOnEditSuccess = {this.updateParentOnEditSuccess}
            CloseLoader = {this.closeLoader}
            buttonDisabled = {this.state.buttonDisabled}
            EditComment = {this.state.editComment}
            HandleCommentActions = {this.handleCommentActions}
            Comments = {this.state.comments}
            CommentId = {this.state.commentId}
            CommentsLoaded = {this.state.commentsLoaded}
            OnDelete = {this.onDelete}
            CommentAction = {this.state.commentAction}
            HrPermission = {this.state.hrPermission}
            LoggedUser = { this.state.loggedUser}
            />
            :
            <ErrorPage Message={'You have no permission to view timeoff request details'} />
            }
            </>
        )
    }
}
